import script from "./form-member.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-member.vue?vue&type=script&setup=true&lang=ts"

import "./form-member.vue?vue&type=style&index=0&id=7f699a72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f699a72"]])

export default __exports__